// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inputs-item-3Scwj {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.inputs-item-3Scwj + .inputs-item-3Scwj {\n  border-top: 1px solid #e0dfde;\n  margin-top: 20px;\n  padding-top: 20px;\n}\n.inputs-leftSide-3G5WH {\n  flex-basis: 33%;\n  line-height: 1.6;\n}\n.inputs-rightSide-2rCwU {\n  flex: 1;\n  overflow-wrap: break-word;\n}\n@media (max-width: 650px) {\n  .inputs-leftSide-3G5WH,\n  .inputs-rightSide-2rCwU {\n    flex-basis: 100%;\n  }\n}\n.inputs-si-content-width-max-m-2IGfj .inputs-leftSide-3G5WH,\n.inputs-si-content-width-max-m-2IGfj .inputs-rightSide-2rCwU {\n  flex-basis: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"item": "inputs-item-3Scwj",
	"leftSide": "inputs-leftSide-3G5WH",
	"rightSide": "inputs-rightSide-2rCwU",
	"si-content-width-max-m": "inputs-si-content-width-max-m-2IGfj"
};
module.exports = exports;
